<template>
    <div class="productClassInfoIntroduction">
        <div class="title">{{name}}</div>
        <div class="main">
            <div class="left">
                <img :src="ip+'/image_product/产品详情/'+productInfo.img" width="100%" height="100%" alt="" srcset="">
            </div>
            <div class="right">
                <div class="top">
                    <div class="title_info">{{$t('产品简介')}}</div>
                    <div class="text">{{text}}</div>
                </div>
                <div class="bottom">
                    <div class="logo_list" v-show="logoList">
                        <img :src="`${baseUrl}img/09m/logo/${item}.jpg`" alt="" srcset="" v-for="(item, index) in logoList" :key="index+200">
                    </div>
                    <div class="btn_box">
                        <div class="btn_item" @click="$router.push('/contact?type=Email')">
                            <img height="50%" src="../../public/img/09m/logo/邮箱.png" alt="" srcset="">
                            Email
                        </div>
                        <div class="btn_item" @click="openMail()">
                            <img height="70%" src="../../public/img/09m/logo/商城.png" alt="" srcset="">
                            {{$t('前往商城')}}
                        </div>                        
                    </div>
                </div>                
            </div>
        </div>
        <div class="banner">
            <div class="left_btn _btn" @click="add()">
                <img src="../../public/img/09m/info_left.png" alt="" srcset="">
            </div>
            <div class="right_btn _btn" @click="cut()">
                <img src="../../public/img/09m/info_right.png" alt="" srcset="">
            </div>
            <div class="swiper-product">
                <div class="swiper-wrapper" >
                    <div class="swiper-slide" v-for="(item, index) in productImgList" @click="setImg(item.img)" :key="index">
                        <img :src="ip+'/image_product/产品详情/'+item.img" alt="" srcset="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Swiper from 'swiper';
export default {
    props:['datas','name','text'],
    created(){
        this.productInfo = this.datas
        console.log(this.productInfo)
        let productId = this.productInfo.productId
        let _this = this
        this.$axios({
            method:'post',
            url:this.ip + '/getProductImg',
            data:this.qs.stringify({
                productId:productId
            }),
            headers:{'Content-Type':'application/x-www-form-urlencoded'}
        }).then((response) =>{          //这里使用了ES6的语法
            _this.productImgList = response.data.data
            setTimeout(()=>{
                _this.mySwipers = new Swiper ('.swiper-product', {
                    loop:false,
                    grabCursor: true,
                    slidesPerView: 'auto',   //设置slider容器能够同时显示的slides数量
                    paginationClickable: true,
                    autoplay: true,
                })
            },500)
        }).catch((error) =>{
            console.log(error)       //请求失败返回的数据
        })
    },
    data() {
        return {
            baseUrl:process.env.BASE_URL,
            productInfo:{},
            productImgList:[],
            mySwipers:null,
        }
    },
    mounted(){
        
    },
    computed:{
        logoList(){
            return JSON.parse(this.productInfo.logo)
        }
    },
    methods:{
        add(){
            this.mySwipers.slidePrev();  
        },
        cut(){
            this.mySwipers.slideNext();            
        },
        openMail(){
            window.open("https://xtyucheng.en.alibaba.com/zh_CN/?spm=a2700.icbuShop.88.10.526c4b3aQhdR7W"); 
        },
        setImg(url){
            this.productInfo.img = url
        }
    }
}
</script>

<style lang="less" scoped>
@width:44.1vw;
@height:@width/0.998;
.productClassInfoIntroduction{
    width: @width;
    min-height: @height;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    .right_btn{
        right: 0;
        top: 50%;
        z-index: 1000;
        transform: translateY(-50%);
    }
    .left_btn{
        left: 0;
        top: 50%;
        z-index: 1000;
        transform: translateY(-50%);
    }
    ._btn{
        width: 3%;
        height: 70%;
        background-color: #017CA8;
        position: absolute;
        border-radius: 3px;
        
        display: flex;
        justify-content: center;
        align-items: center;
        img{
            width: 50%;
        }
    }
    .swiper-product{
        width: 90%;
        height: 100%;
        margin: 0 auto;
        overflow: hidden;        
        .swiper-wrapper{
            width: 100%;
            position: relative;
            .swiper-slide{
                width: 25%;
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                    width: 90%;
                    height: 90%;
                    border: 1px solid #777777;
                }
            }
        }
        
    }
    .title_info{
        width: 100%;
        min-height: 0.093*@height;
        line-height: 0.093*@height;
        color: #4C4C4C;
        font-family: "YHBD";
    }
    .text{
        color: #4C4C4C;
        font-size: 0.8rem;
        line-height: 1.3rem;
    }
    .title{
        width: 100%;
        min-height: 0.093*@height;
        // background-color: antiquewhite;
        line-height: 0.093*@height;
        color: #017CA8;
        font-family: "YHBD";
        border-bottom: 1px solid #7f7f7f;
    }
    .line{
        background-color: #7F7F7F;
        width: 100%;
        height: 1px;
    }
    .main{
        width: 100%;
        min-height: 0.613*@height;
        // background-color: aquamarine;
        display: flex;
        justify-content: space-between;
        .left{
            width: 60%;
            height: 100%;
            border: 1px solid #A5A5A5;
        }
        .right{
            width: 38%;
            min-height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-direction: column;
            .top{
                width: 100%;
                min-height: 30px;
            }
            .bottom{
                width: 100%;
                min-height: 30px;
                .btn_box{
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    margin-top: 10px;
                    .btn_item{
                        min-width: 48%;
                        // padding: 0 20px;
                        min-height: 30px;
                        height: 1rem;
                        background-image: linear-gradient(45deg,#009D40,#007CA9);
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                        justify-content: center;
                        font-size: 0.6rem;
                        font-weight: bold;
                        color: #fff;
                        img{
                            margin-right: 10px;
                        }
                    }
                }
                .logo_list{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    img{
                        width: 32%;
                    }
                }
            }
        }
    }
    .banner{
        width: 100%;
        height: 0.216*@height;
        position: relative;
        // background-color: rgb(8, 109, 75);
    }
}
</style>

